import _ from "lodash";
import mixin from '@general/lib/mixin';
import { eventPhotosSort } from '@buddy/lib/helpers'
import { initialState } from '@buddy/store'

const mutations = {
    setHealthAlert(state, value){
        state.healthAlert = value
    },
    updateSidebarVisibility(state, { index, value }){
        state.sidebar[index].visible = value
    },
    updateDialog(state, payload){
        state.dialog = {...state.dialog, ...payload}
    },
    setAvailableEmojies(state,payload){
        state.availableEmojies = payload;
    },
    setFavoritesPage(state,payload){
        state.favoritesPage = payload;
    },
    setFavorites(state,payload){
        state.favourites = payload;
    },
    setModal(state, payload){
        state.modal = {...state.modal, ...payload}
    },
    setSpotTags(state, payload){
        state.spot_tags = payload;
    },
    setUser(state, profile) {
        state.profile = profile;
    },
    setSupportUser(state, user) {
        state.supportUser = user;
    },
    clearBlockedUsers(state) {
        state.profileBlockedUsers = [];
    },
    setBlockedUsers(state, blockedUsers) {
        state.profileBlockedUsers.push(...blockedUsers);
    },
    setHaveUnblockedUsers(state, value) {
        state.haveUnblockedUsers = value;
    },
    updateBlockedUsers(state, blockedUserId) {
        let index = state.profileBlockedUsers.findIndex((user) => {return user.id === blockedUserId})

        if (index !== -1) {
            Vue.delete(state.profileBlockedUsers, index);
        }
    },
    setPrepUser(state, user) {
        state.prepUser = user;
    },
    updateUser (state, object) {
        for (let key in object) {
            if (object.hasOwnProperty(key)) {
                Vue.set(state.profile, key, object[key])
            }
        }
    },
    setProfileOptions(state, options) {
        state.profileOptions = options;
    },
    setProfilePhotos(state, photos) {
        state.profilePhotos = photos;
    },
    setProfileVideos(state, videos) {
        state.profileVideos = videos;
    },
    setMyEvents(state, events) {
        state.myEvents = events
        state.myEventsLoaded = true
    },
    setInvitationsToBang(state, invitations) {
        state.invitationsToBang = invitations
    },
    openAdminPopUp(state,payload){
        state.showedAdminPopUp.info = payload.popup;
        state.showedAdminPopUp.active = true;
        state.showedAdminPopUp.page = payload.page;
    },
    closeAdminPopUp(state, popUp){
        state.showedAdminPopUp.active = false;
        state.adminPopUps = store.state.adminPopUps.filter((v) => v.id !== popUp.id)
    },
    setAdminPopUps(state,popUps){
      state.adminPopUps = popUps;
    },
    setMyClubs(state, myClubs) {
        state.myClubs = myClubs
    },
    setInvitationsToClub(state, invitations) {
        state.invitationsToClub = invitations
    },
    addMyEvents(state, events) {
        state.myEvents.push(...events)
    },
    removeFromMyEvents(state, eventId) {
        let eventIndex = state.myEvents.findIndex(el => el.id == eventId)
        if (eventIndex !== -1) {
            console.log('[removeFromMyEvents]', { eventIndex })
            Vue.delete(state.myEvents, eventIndex)
        }
    },
    updateMyEvent(state, eventData) {
        // My events
        let myEventsIndex = state.myEvents.findIndex(v => v.id == eventData.id)
        if (myEventsIndex !== -1) {
            Vue.set(
                state.myEvents,
                myEventsIndex,
                {...state.myEvents[myEventsIndex], ...eventData}
            )
        }
    },
    addPhoto(state, photo) {
        state.profilePhotos.unshift(photo);
    },
    removeVideo(state, video) {
        let videoIndex = state.profileVideos.findIndex(el => el.hash === video.hash)
        if (videoIndex !== -1) {
            Vue.delete(state.profileVideos, videoIndex)
        }
    },
    addVideo(state, video) {
        let videoIndex = state.profileVideos.findIndex(el => el.hash === video.hash)
        if (videoIndex !== -1) {
            Vue.set(state.profileVideos, videoIndex, video)
        } else {
            state.profileVideos.unshift(video)
        }
    },
    updateVideo(state, payload) {
        let index = state.profileVideos.findIndex(el => el.id === payload.newVideo.id);
        if (index !== -1) {
            Vue.set(state.profileVideos, index, payload.newVideo);
        }
    },
    updateVideoPercentage(state, payload) {
        let index = state.profileVideos.findIndex(el => el.hash === payload.hash);
        if (index !== -1) {
            Vue.set(state.profileVideos, index, payload);
        }
    },
    updatePhoto(state, { photoId, data }) {
        let photoIndex = state.profilePhotos.findIndex(el => el.id === photoId)
        if (photoIndex !== -1) {
            Vue.set(state.profilePhotos, photoIndex, data)
        }
    },
    logout(state) {
        state = _.cloneDeep(initialState)
    },
    setOnlineFavorites(state, favorites) {
        state.onlineFavorites = favorites;
    },
    setFavoritesCount(state, favoritesCount) {
        state.favoritesCount = favoritesCount
    },
    setBlockedCount(state, blockedCount) {
        state.blockedCount = blockedCount
    },
    setBlockedUsersIds(state, blockedUsersIds) {
        state.blockedUsersIds = blockedUsersIds
    },
    updateOnlineFavorites(state, favorites) {
        state.onlineFavorites.forEach(favUser => {
            const newUser = favorites.find(el => el.id == favUser.id);

            favUser.distanceMeters = newUser.distanceMeters ;
            //favUser.last_active = mixin.methods.convertUtcToLocal(newUser.last_active);
            favUser.isOnline = newUser.isOnline ;
            favUser.wasRecentlyOnline = newUser.wasRecentlyOnline;
        })
    },

    /**
     * set meet now users
     */
    setMeetNowUsers(state, meet_now_users){
        state.meetNowUsers = meet_now_users;
    },

    setTimeZones(state, timezones){
        state.timezones = timezones;
    },

    /**
     * set discreet mode status
     */
    setDiscreetMode(state, status) {
        state.discreetMode = status
    },
    /**
     * set user is pro status
     */
    setUserIsPro(state, status) {
        state.userIsPro = status
    },
    /**
     * set user latest used widget
     */
    setLatestWidget(state, status) {
        state.latestWidget = status
    },
    /**
     * open profile edit
     */
    openProfileEdit(state) {
        state.profileEditOpened         = true

        state.profileLocationOpened     = false
        state.profilePhotosOpened       = false
        state.profileVideosOpened       = false
        state.profileSettingsOpened     = false
        state.profileShareOpened        = false
        state.profileDeactivationOpened = false
        state.customizeSharingLinksOpened = false
        state.deleteAllSharingLinksOpened = false
        state.profileHelpOpened         = false
    },
    /**
     * close profile edit
     */
    closeProfileEdit(state) {
        state.profileEditOpened = false
    },
    /**
     * open location menu from profile sidebar
     */
    openProfileLocation(state) {
        state.profileLocationOpened     = true

        state.profileEditOpened         = false
        state.profilePhotosOpened       = false
        state.profileVideosOpened       = false
        state.profileSettingsOpened     = false
        state.profileShareOpened        = false
        state.profileDeactivationOpened = false
        state.customizeSharingLinksOpened = false
        state.deleteAllSharingLinksOpened = false
        state.profileHelpOpened         = false
    },
    /**
     * close location menu from profile sidebar
     */
    closeProfileLocation(state) {
        state.profileLocationOpened = false
    },
    /**
     * open photos menu from profile sidebar
     */
    openProfilePhotos(state) {
        state.profilePhotosOpened = true

        state.profileEditOpened         = false
        state.profileLocationOpened     = false
        state.profileVideosOpened       = false
        state.profileSettingsOpened     = false
        state.profileShareOpened        = false
        state.profileDeactivationOpened = false
        state.customizeSharingLinksOpened = false
        state.deleteAllSharingLinksOpened = false
        state.profileHelpOpened         = false
    },
    /**
     * close photos menu from profile sidebar
     */
    closeProfilePhotos(state) {
        state.profilePhotosOpened = false
    },
    /**
     * open videos menu from profile sidebar
     */
    openProfileVideos(state) {
        state.profileVideosOpened = true

        state.profileEditOpened         = false
        state.profileLocationOpened     = false
        state.profilePhotosOpened       = false
        state.profileSettingsOpened     = false
        state.profileShareOpened        = false
        state.profileDeactivationOpened = false
        state.customizeSharingLinksOpened = false
        state.deleteAllSharingLinksOpened = false
        state.profileHelpOpened         = false
    },
    /**
     * close videos menu from profile sidebar
     */
    closeProfileVideos(state) {
        state.profileVideosOpened = false
    },
    /**
     * open settings menu from profile sidebar
     */
    openProfileSettings(state) {
        state.profileSettingsOpened = true

        state.profileEditOpened         = false
        state.profileLocationOpened     = false
        state.profilePhotosOpened       = false
        state.profileVideosOpened       = false
        state.profileShareOpened        = false
        state.profileDeactivationOpened = false
        state.customizeSharingLinksOpened = false
        state.deleteAllSharingLinksOpened = false
        state.profileHelpOpened         = false
    },
    /**
     * close settings menu from profile sidebar
     */
    closeProfileSettings(state) {
        state.profileSettingsOpened = false
    },


    /**
     * open moderate images menu from profile sidebar
     */
    openModeration(state) {
        state.profileModerationOpened   = true;

        state.profileShareOpened        = false
        state.profileEditOpened         = false
        state.profileLocationOpened     = false
        state.profilePhotosOpened       = false
        state.profileSettingsOpened     = false
        state.profileDeactivationOpened = false
        state.customizeSharingLinksOpened = false
        state.deleteAllSharingLinksOpened = false
        state.profileHelpOpened         = false
    },

    /**
     * open share menu from profile sidebar
     */
    openProfileShare(state) {
        state.profileShareOpened = true

        state.profileEditOpened         = false
        state.profileLocationOpened     = false
        state.profilePhotosOpened       = false
        state.profileSettingsOpened     = false
        state.profileDeactivationOpened = false
        state.customizeSharingLinksOpened = false
        state.deleteAllSharingLinksOpened = false
        state.profileHelpOpened         = false
    },
    /**
     * close settings menu from profile sidebar
     */
    closeProfileShare(state) {
        state.profileShareOpened = false
    },


    /**
     * close settings menu from profile sidebar
     */
    closeProfileModerations(state) {
        state.profileModerationOpened = false
    },



    /**
     * open deactivation menu from profile settings
     */
    openProfileDeactivation(state) {
        state.profileDeactivationOpened = true
        state.deleteAllSharingLinksOpened = false
        state.customizeSharingLinksOpened = false
    },

    /**
     * open openCustomizeSharingLinks menu from profile settings
     */
    openCustomizeSharingLinks(state) {
        state.customizeSharingLinksOpened = true
        state.deleteAllSharingLinksOpened = false
    },

    /**
     * open delete all sharing links menu from profile settings
     */
    openDeleteAllSharingLinks(state) {
        state.deleteAllSharingLinksOpened = true
        state.profileDeactivationOpened = false
        state.customizeSharingLinksOpened = false
    },

    /**
     * close deactivation menu from profile settings
     */
    closeProfileDeactivation(state) {
        state.profileDeactivationOpened = false
    },

    /**
     * close delete all sharing links menu from profile settings
     */
    closeDeleteAllSharingLinks(state) {
        state.deleteAllSharingLinksOpened = false
    },

    /**
     * close openProfileDeactivation menu from profile settings
     */
    closeCustomizeSharingLinks(state) {
        state.customizeSharingLinksOpened = false
    },

    /**
     * open help menu from profile sidebar
     */
    openProfileHelp(state) {
        state.profileHelpOpened = true

        state.profileEditOpened         = false
        state.profileLocationOpened     = false
        state.profilePhotosOpened       = false
        state.profileVideosOpened       = false
        state.profileShareOpened        = false
        state.profileDeactivationOpened = false
        state.customizeSharingLinksOpened = false
        state.deleteAllSharingLinksOpened = false
        state.profileSettingsOpened     = false
    },
    /**
     * close help menu from profile sidebar
     */
    closeProfileHelp(state) {
        state.profileHelpOpened = false
    },
    closeAllProfilePages(state) {
        state.profileHelpOpened = false
        state.profileEditOpened = false
        state.profileLocationOpened = false
        state.profilePhotosOpened = false
        state.profileVideosOpened = false
        state.profileDeactivationOpened = false
        state.customizeSharingLinksOpened = false
        state.deleteAllSharingLinksOpened = false
        state.profileSettingsOpened = false
        state.profileShareOpened = false
    },
    /**
     * show Requirements Alert modal
     */
    showRequirementsAlert(state, type) {
        state.requirementsAlert.isShow      = true
        state.requirementsAlert.type        = type
        state.requirementsAlert.image       = '/images/splash/'+ type + '.svg'
        state.requirementsAlert.title       = app.trans('splash_' + type + '_title')
        state.requirementsAlert.description = app.trans('splash_' + type + '_description')
        state.requirementsAlert.button      = ['change_settings', 'location', 'notifications'].includes(type) ? app.trans(type === 'notifications' ? 'notifications_button' : (type === 'location' ? 'location_button' : type)) : app.trans('upgrade_now')
        state.requirementsAlert.withProIcon = ['change_settings', 'location', 'notifications'].includes(type) ? false : true

        switch (type) {
            case 'notifications':
                state.requirementsAlert.image = '/assets/img/svg/notification_active_green.svg'
                state.requirementsAlert.imageStyle = 'width: 120px; margin: 20px auto;'
                break;

            case 'change_settings':
                state.requirementsAlert.imageStyle = 'width: 50%'
                break;

            case 'media':
                state.requirementsAlert.imageStyle = 'margin: 30px auto; width: 75%'
                break;

            case 'deletemsg':
                state.requirementsAlert.imageStyle = 'margin: 0 auto 24px; width: 100%'
                break;

            case 'filters':
                state.requirementsAlert.imageStyle = 'margin: 0 auto; width: 71%'
                break;

            case 'favorites':
                state.requirementsAlert.imageStyle = 'margin: 40px auto 25px; width: 50%'
                break;

            case 'visitors':
                state.requirementsAlert.imageStyle = 'margin: 48px auto 25px; width: 60%'
                break;

            case 'events':
                state.requirementsAlert.imageStyle = 'margin: 35px auto 20px; width: 46%'
                break;
                
            case 'clubs':
                state.requirementsAlert.imageStyle = 'margin: 35px auto 20px; width: 46%'
                break;

            case 'location':
                state.requirementsAlert.imageStyle = 'width: 35%'
                break;

            default:
                state.requirementsAlert.imageStyle = 'width: 44%'
                break;
        }
    },
    /**
     * hide Requirements Alert modal
     */
    hideRequirementsAlert(state) {
        if(state.requirementsAlert.type === 'location') {
            if (!localStorage.getItem('location')) {
                mixin.methods.showLoadingButton('#requirement_button')
                axios.post('/api/register/find-location')
                    .then(response => {
                        //all is good, close location alert
                        state.requirementsAlert.isShow = false;
                    }).catch((e) => {
                        mixin.methods.decodeLocation(function (){
                            location.reload();
                        },function(){
                            mixin.methods.restoreLoadingButton('#requirement_button')
                        });
                    })
            }else{
                state.requirementsAlert.isShow = false;
            }
        }else{
            state.requirementsAlert.isShow = false;
        }
    },
    /**
     * show Announce Alert modal
     */
    showAnnounceAlert(state, data) {
        state.announceAlert.isShow  = true
        state.announceAlert.message = data.message
    },
    /**
     * hide Announce Alert modal
     */
    hideAnnounceAlert(state) {
        state.announceAlert.isShow = false
    },
    setTapped(state) {
        state.isTapped = true
    },
    setMyTaps(state, taps) {
        if(taps){
            taps.forEach(el => {
                el.idate = mixin.methods.convertUtcToLocal(el.idate);
            });
            state.myTaps = taps;
        }else{
            state.myTaps = [];
        }
    },
	addMyTap(state, tap) {
        state.myTaps.push(tap)
    },
	setLocationUpdating(state, value) {
        state.locationUpdating = value
    },
    setSharingUrl(state, value) {
        state.sharingUrl = value;
    },
    setSocketStatus(state,value) {
        state.socketConnected = value;
    }
}

export default mutations
